import {memo} from "react";

export const CustomRadioComponent = memo(({checked, onChange, ...props}) => {
    return (<label className="tw-relative tw-w-6 tw-h-6 tw-mr-2 tw-mt-2">
        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="tw-absolute tw-inset-0 tw-opacity-0 tw-cursor-pointer"
        />
        <div
            className={`tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-transition-colors ${checked ? "tw-bg-[#0B9C07] border-green-700" : "tw-bg-transparent tw-border-gray-400"}`}
        >
            {checked ? (<svg
                className="tw-w-3 tw-h-3 tw-text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
            >
                <polyline points="20 6 9 17 4 12"/>
            </svg>) : null}
        </div>
    </label>);
});
